import React from "react";
import "./UpcomingEvents.css";

const UpcomingEvents = () => {
    const upcomingEventsImage = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/crete-tournament.jpg"
  return (
    <div className="upcoming-events-section">
      <h2 className="section-title">Upcoming Event</h2>
      <div className="upcoming-events-content">
        {/* Left: Text */}
        <div className="events-text">
          <h3>Champions League Socca Tournament – Crete, Greece</h3>
          <p>
            Get ready for an unforgettable football experience! The Champions League 
            Socca Tournament is taking place in <strong>Crete, Greece</strong> from 
            <strong> 14th – 19th October</strong>.
          </p>
          <p>
            Our Gladiators are stepping onto the big stage to represent with passion, 
            determination, and skill. This is more than just football – it’s about unity, 
            pride, and the love of the game.
          </p>
          <p className="encouragement">
            Come and cheer with us, bring your energy, and let’s make history together!
          </p>
        </div>

        {/* Right: Event Image */}
        <div className="image-container">
          <img 
            src={upcomingEventsImage} 
            alt="Champions League Socca Tournament in Crete, Greece" 
            className="event-image" 
          />
        </div>
      </div>
    </div>
  );
};

export default UpcomingEvents;
